//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { TemplateHelper, ConfigHelper, LocalizationHelper } from "../../helpers"
import { Activity, Enums } from "../../models/common"

import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../user-session"
import { SYSTEM_CONTEXT_LIST_SERVICE_NAME, SystemContextListService } from "../system"

//#region Public Types

export const TARIFF_CONTEXT_MENU_SERVICE_NAME = 'tariffContextMenuService'
export const TARIFF_CONTEXT_MENU_SERVICE_PROVIDER_NAME = 'tariffContextMenuServiceProvider'

export type TariffGridContextMenuOptions = {
    idReferenceTypes?: number[]
    onEdit?: () => void
    onCopy?: () => void
}

//#endregion

export class TariffContextMenuService {

    // #region Ctor

    public constructor(
        private readonly systemContextListService: SystemContextListService,
        private readonly userSessionService: UserSessionService
    ) { }

    // #endregion


    // #region Public Methods

    public getContextMenuItems(options: TariffGridContextMenuOptions): any[] {
        const items: { beginGroup?: boolean, template: string, onItemClick: (args: any) => void }[] = []

        if (options == null) {
            return items
        }

        let beginGroup: boolean = true

        if (options.onEdit != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.TARIFF_EDIT)) {
            items.push({
                beginGroup: beginGroup,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit), ConfigHelper.Icon.EDIT, this.userSessionService),
                onItemClick: (e: any) => {
                    options.onEdit()
                }
            })

            beginGroup = false
        }

        if (
            _.size(options.idReferenceTypes) === 1
            && options.onCopy != null
            && this.userSessionService.getLoggedOperator().hasPermission(Activity.TARIFF_COPY)
        ) {
            items.push({
                beginGroup: beginGroup,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.CopyTariff), ConfigHelper.Icon.CONTENT_COPY, this.userSessionService),
                onItemClick: (e: any) => {
                    options.onCopy()
                }
            })

            beginGroup = false
        }

        beginGroup = true

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.SIM_CARD_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.SIM_CARD_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SimCardModule)) {
            items.push({
                beginGroup: beginGroup,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowSimCards), ConfigHelper.Icon.SIM_CARD, this.userSessionService),
                onItemClick: (e: any) => {
                    this.systemContextListService.getContextList(Enums.ReferenceType.IdSimCard, options.idReferenceTypes, Enums.ReferenceType.IdTariff)
                }
            })

            beginGroup = false
        }

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationModule)) {
            items.push({
                beginGroup: beginGroup,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowLocations), ConfigHelper.Icon.LOCATIONS, this.userSessionService),
                onItemClick: () => {
                    this.systemContextListService.getContextList(Enums.ReferenceType.IdLocation, options.idReferenceTypes, Enums.ReferenceType.IdTariff)
                }
            })

            beginGroup = false
        }

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterModule)) {
            items.push({
                beginGroup: beginGroup,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowMeters), ConfigHelper.Icon.METERS, this.userSessionService),
                onItemClick: () => {
                    this.systemContextListService.getContextList(Enums.ReferenceType.IdMeter, options.idReferenceTypes, Enums.ReferenceType.IdTariff)
                }
            })

            beginGroup = false
        }

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DeviceModule)) {
            items.push({
                beginGroup: beginGroup,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowDevices), ConfigHelper.Icon.DEVICES, this.userSessionService),
                onItemClick: () => {
                    this.systemContextListService.getContextList(Enums.ReferenceType.SerialNbr, options.idReferenceTypes, Enums.ReferenceType.IdTariff)
                }
            })

            beginGroup = false
        }

        return items
    }

    // #endregion
}

export class TariffContextMenuServiceProvider
    implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [SYSTEM_CONTEXT_LIST_SERVICE_NAME, USER_SESSION_SERVICE_NAME, function (systemContextListService: SystemContextListService, userSessionService: UserSessionService) {
        return new TariffContextMenuService(systemContextListService, userSessionService)
    }]

    //#endregion
} 
